import { render, staticRenderFns } from "./scale.vue?vue&type=template&id=1dd778c0&scoped=true&"
import script from "./scale.vue?vue&type=script&lang=js&"
export * from "./scale.vue?vue&type=script&lang=js&"
import style0 from "./scale.vue?vue&type=style&index=0&id=1dd778c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd778c0",
  null
  
)

export default component.exports